import { render, staticRenderFns } from "./agreements.vue?vue&type=template&id=c1fbbf9a&scoped=true"
import script from "./agreements.vue?vue&type=script&lang=js"
export * from "./agreements.vue?vue&type=script&lang=js"
import style0 from "./agreements.vue?vue&type=style&index=0&id=c1fbbf9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fbbf9a",
  null
  
)

export default component.exports